import Config from '../utils/Config';
import Promise from 'promise';

const GeoLocationService = {
    geocodeZip: (zipCode) => {
        var googleMapsLoader = require('google-maps');
        googleMapsLoader.KEY = Config.GOOGLE_MAPS_API_KEY;

        return new Promise((resolve, reject) => {
            googleMapsLoader.load(() => {
                var geocoder = new google.maps.Geocoder();

                geocoder.geocode({
                    address: zipCode
                }, (response, status) => {
                    if (status === google.maps.GeocoderStatus.OK) {

                        let returnObject = {};

                        for (var i = 0, l = response[0].address_components.length; i < l; i++) {
                            let component = response[0].address_components[i];
                            switch (component.types[0]) {
                                case 'locality':
                                    returnObject.city = component.short_name;
                                    break;
                                case 'administrative_area_level_1':
                                    returnObject.state = component.short_name;
                                    break;
                                case 'postal_code':
                                    returnObject.postalCode = component.short_name;
                                    break;
                            }
                        }

                        resolve(returnObject);
                    }

                    reject("Error");
                });
            });
        });
    }
}

export default GeoLocationService;


// WEBPACK FOOTER //
// ./src/services/GeoLocationService.js